export const defaultMinimumSpendPence = 2000
